<template>
    <b-container class="bv-example-row">
        <alert :message="message" />
        <b-row>
            <b-col md="12">
                <h3>List of projects</h3>
            </b-col>
        </b-row>

        <div class="overflow-auto">

            <b-form-group label="Filter by name" label-for="filter-input" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <b-form-input id="filter-input" v-model="filter_by_project" type="search" placeholder="Type to Search"
                        v-on:keyup.enter="download_list_of_projects"></b-form-input>

                </b-input-group>
            </b-form-group>

            <b-form-group label="Filter by uuid" label-for="filter-input" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <b-form-input id="filter-input" v-model="filter_by_uuid" type="search" placeholder="Type to Search"
                        v-on:keyup.enter="download_list_of_projects"></b-form-input>

                </b-input-group>
            </b-form-group>

            <b-button @click="download_list_of_projects" variant="primary" class="mb-3">Filter</b-button>

            <b-table id="my-table" :items="projects" :per-page="perPage" :current-page="currentPage" :fields="fields" small
                striped fixed :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                <template v-slot:cell(name)="data">
                    <div class="w-100 text-truncate overflow-hidden">
                        <router-link :to="'/project/' + data.item.uuid">{{ data.value }}</router-link>
                    </div>

                </template>
                <template v-slot:cell(space_name)="data">
                    <router-link :to="'/space/' + data.item.space_uuid">{{ data.value }}</router-link>
                </template>

                <template v-slot:cell(updated_at)="data">
                    <span>{{ new Date(data.value).toLocaleString() }}</span>
                </template>

                <template v-slot:cell(creator_email)="data">
                    <router-link :to="'/user/' + data.item.creator_uuid">{{ data.value }}</router-link>
                </template>
            </b-table>

            <b-pagination v-model="currentPage" :total-rows="this.totalRows" :per-page="perPage" align="fill" size="sm"
                class="my-0"></b-pagination>
        </div>

    </b-container>
</template>

<script>
import Alert from '../components/alert.vue';

export default {
    data() {
        return {
            message: '',
            perPage: 20,
            currentPage: 1,
            totalRows: null,
            projects: [],
            filter_by_project: null,
            filter_by_uuid: null,
            fields: [
                { key: 'name', class: 'text-center align-middle', sortable: true },
                { key: 'uuid', label: 'UUID', class: 'text-center align-middle' },
                { key: 'space_name', label: 'Space name', class: 'text-center align-middle', sortable: true },
                { key: 'creator_email', label: 'Created by', class: 'text-center align-middle' },
                { key: 'updated_at', label: 'Updated at', class: 'text-center align-middle', sortable: true }
            ],
            sortBy: "updated_at",
            sortDesc: true,
        }
    },
    components: {
        alert: Alert,
    },
    methods: {
        init() {
            this.download_list_of_projects()
        },
        download_list_of_projects() {
            this.$http.get(this.$apiURL + '/admin/projects',
                {
                    headers: this.$store.getters.authHeader,
                    params: { name: this.filter_by_project, uuid: this.filter_by_uuid }
                })
                .then((res) => {
                    console.log(res.data)
                    this.projects = res.data
                    this.totalRows = this.projects.length
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
    },
    created() {
        this.init();
    },
}
</script>
